import type { AuthResponse } from '~/interfaces/common';
import { fetchJson } from '~/utils/fetch-json';
import { removeLocalStorageItem } from '~/utils/local-storage';

export abstract class LoginHandler<E = unknown, T = unknown> {
  #originName!: string;

  constructor(originName: string) {
    this.#originName = originName;
  }

  protected abstract transformRequestBody(body: E): T;

  private async sendLoginRequest(body: T) {
    const res = await fetchJson<AuthResponse>(
      `/origins/${this.#originName}/connect`,
      {
        method: 'POST',
        body: JSON.stringify(body),
      },
    );

    if (res) {
      removeLocalStorageItem('alias');
      removeLocalStorageItem('originName');
      removeLocalStorageItem('authFlow');
      removeLocalStorageItem('originalChallengeParams');
    }
    return res;
  }

  public async handle(body: E) {
    const transformedBody = this.transformRequestBody(body);
    return this.sendLoginRequest(transformedBody);
  }
}
